const { isEmpty } = require('lodash');

const statuses = {
  open: { label: '未完了', color: 'warning' },
  done: { label: '完了', color: 'success' },
};

// 操作履歴(Activity)のtype→表示ラベル対応
const activityTypes = {
  createTask: { text: (_) => '作成' },
  createChildTask: { text: (_) => '子タスク作成' },
  duplicateTask: { text: (_) => '複製' },
  updateTask: { text: (_) => '編集' },
  completeTask: { text: (_) => '完了' },
  uncompleteTask: { text: (_) => '未完了に戻す' },
  deleteTask: { text: (_) => '削除' },
  addTaskComment: { text: (_) => 'コメント' },
};

// タスク作成・編集フォームのフィールド定義。
// 担当(assignee)・親タスク(parentTaskId)の選択肢は動的なので呼び出し側から options を渡す。
// showsParent=true のときのみ親タスク選択欄を出す（子タスク作成時など親が確定している場合は出さない）。
// contextPath を渡すと「作成元(画面)を紐づける」チェックボックスを出す（外せば紐づけなしにできる）。
const remindTimingUnits = {
  hours: { label: '時間前' },
  days: { label: '日前' },
};

const remindTimingHours = (timing) => timing.amount * (timing.unit === 'days' ? 24 : 1);

const remindTimingLabel = (timing) => `${timing.amount}${remindTimingUnits[timing.unit]?.label || ''}`;

const taskRemindTimingFields = () => {
  return {
    amount: {
      type: 'integer',
      label: '数値',
      validations: {
        required: (_) => _ != null,
        greaterThan0: (_) => _ > 0,
      },
    },
    unit: {
      type: 'select',
      label: '単位',
      options: Object.entries(remindTimingUnits).map(([value, { label }]) => ({ label, value })),
      validations: {
        required: (_) => !isEmpty(_),
      },
    },
  };
};

const taskFields = ({ assigneeOptions = [], parentTaskOptions = [], showsParent = false, contextPath = null, remindTimingOptions = [] } = {}) => {
  return {
    title: {
      type: 'string',
      label: 'タスク名',
      validations: {
        required: (_) => !isEmpty(_),
      },
    },
    description: {
      type: 'richText',
      label: '説明',
      rows: 4,
    },
    assignee: {
      type: 'select',
      label: '担当',
      options: assigneeOptions,
    },
    dueDate: {
      type: 'datetime',
      label: '期限',
    },
    remindTimingIds: {
      type: 'multiSelect',
      label: 'リマインド',
      options: remindTimingOptions,
      initialValue: [],
      hidden: (_) => !_.dueDate,
      hint: '期限の指定時間前に担当者へメールでお知らせします',
    },
    ...(showsParent && {
      parentTaskId: {
        type: 'select',
        label: '親タスク',
        options: parentTaskOptions,
        hint: '子タスクにする場合は親タスクを選択してください',
      },
    }),
    ...(contextPath && {
      attachContext: {
        type: 'boolean',
        label: `作成元の画面（${contextPath}）を紐づける`,
        hint: '外すと作成元の画面を紐づけません',
      },
    }),
  };
};

const commentFields = () => {
  return {
    body: {
      type: 'richText',
      label: 'コメント内容',
      validations: {
        required: (_) => !isEmpty(_),
      },
    },
  };
};

const hasUnreadComment = (task, uid) => {
  if (!uid || !task.lastCommentedAt || task.lastCommentedBy?.uid === uid) return false;
  if (![task.assignee?.uid, task.addedBy?.uid].includes(uid)) return false;

  const readAt = task.commentReadAtByUid?.[uid];
  return !readAt || task.lastCommentedAt.toMillis() > readAt.toMillis();
};

module.exports = {
  statuses,
  hasUnreadComment,
  activityTypes,
  remindTimingUnits,
  remindTimingHours,
  remindTimingLabel,
  taskRemindTimingFields,
  taskFields,
  commentFields,
};
